import { gql } from '@apollo/client';

export const availableDatesAndTimes = gql`
  query availableDatesAndTimes(
    $serviceLocationId: String!
    $consultationId: String!
    $consultationType: ConsultationType!
  ) {
    node(id: $serviceLocationId) {
      ... on ServiceLocation {
        type
        id
        availableAppointments(
          consultationServiceId: $consultationId
          consultationType: $consultationType
        ) {
          date
          time
        }
      }
    }
  }
`;
